import { render } from "./VideosDetail.vue?vue&type=template&id=a9690210"
import script from "./VideosDetail.vue?vue&type=script&lang=js"
export * from "./VideosDetail.vue?vue&type=script&lang=js"

import "./VideosDetail.vue?vue&type=style&index=0&id=a9690210&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__